import React from "react";
import PropTypes from "prop-types";
import { Card } from "antd";
import CaseCountsContainer from "../../common/case-counts-container";

const styles = {
  cardContent: {
    width: "100%",
    overflow: "auto",
    padding: 0
  }
};

const Overview = props => {
  const { name, type } = props;
  const queryCommon = { [`judges.${type}`]: name, sort: "-filing_date" };
  const queriesPTAB = [
    ["total", { ...queryCommon }],
    ["pending", { up_status: "Pending", ...queryCommon }],
    ["notInstituted", { up_status: "Not Instituted", ...queryCommon }],
    ["finalWrittenDecision", { up_status: "Terminated", up_substatus: "Final Written Decision", ...queryCommon }],
    ["settlement", { up_status: "Terminated", up_substatus: "Settlement", ...queryCommon }],
    ["adverseJudgment", { up_status: "Terminated", up_substatus: "Adverse Judgment", ...queryCommon }]
  ];
  return (
    <Card title="PTAB Overview" bodyStyle={styles.cardContent} style={props.style}>
      <CaseCountsContainer type="ptab" queries={queriesPTAB} />
    </Card>
  );
};
Overview.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["author", "panel"]).isRequired
};

export default Overview;
